export const UIParams = () => {
    return {
        modalSearchMaxWidth: 300
    };
};